import store from 'store';
import { NavigateFunction, useNavigate } from 'react-router-dom';
import {
  ANALYTICS_FILTERS,
  ANALYTICS_ACCOUNTS_DATA,
  CONTACT_ANALYTICS,
  CONTENT_ANALYTICS,
  ANALYTICS_ACCOUNTS_DASHBOARD,
  ANALYTICS_CARD_DATA,
  ANALYTICS_DASHBOARD_GRAPH_DATA,
  ANALYTICS_INTENT_DATA,
  ANALYTICS_DASHBOARD,
  ANALYTICS_DASHBOARD_SET_APPLIED_CAMPAIGNS_ASSETS,
  ANALYTICS_EMAIL_TRENDS,
  ANALYTICS_CLICK_TRENDS,
  ANALYTICS_DASHBOARD_SET_SELECTED_ASSETS,
} from 'constants/types/analyticsTypes';
import { removeQueryParams } from 'utils';
import { getAnalyticsFilterService, saveAnalyticsFilterService } from 'modules/Services/AnalyticsService';
import { getAnalyticsFilterId } from 'modules/EmailBrowser/utils';
import {
  analyticsDatesFilterChange,
  getAnalyticsCampaignsAssetsList,
  reorderCampaignsAndEmails,
  reorderWorkflows,
  resetDashboardCampaignFilters,
  resetTestEmailAssetsFilter,
  selectAllCampaigns,
  selectAllEmails,
  selectAsset,
  selectCampaign,
  selectMultipleAssets,
  selectWorkflowAsset,
  setCampaignsFilter,
  setDailyIqFilter,
  setDefaultWorkflow,
  setEmailDropdownFields,
  setShareProfileFilter,
  setTestEmailAssetsFilter,
  setWeeklyAccountInsightsFilter,
  setWorkflowAssetsFilter,
  toggleWorkflowFilter,
  unselectAllWorkflowEmails,
  unselectMultipleAssets,
} from './Dashboard/actions';
import { ISearchedEmailDropdownList } from './interfaces';

const updateTestEmailFilter = () => {
  const testEmailFilter = store.getState().analyticsDashboard.isTestEmailFilter;
  const filters = JSON.parse(localStorage.getItem('analyticsFiltersWithId') as string);
  if (filters) {
    filters.saved_data.include_test_email = testEmailFilter;
    localStorage.removeItem('analyticsFiltersWithId');
    localStorage.setItem('analyticsFiltersWithId', JSON.stringify(filters));
  }
};

export const filterButtonPressed = (isFilterClicked: boolean, history: NavigateFunction) => {
  store.dispatch({
    type: ANALYTICS_ACCOUNTS_DATA.RESET,
  });
  store.dispatch({
    type: CONTACT_ANALYTICS.RESET_ALL,
  });
  store.dispatch({
    type: CONTENT_ANALYTICS.RESET,
  });
  store.dispatch({
    type: ANALYTICS_ACCOUNTS_DASHBOARD.RESET,
  });
  store.dispatch({
    type: ANALYTICS_DASHBOARD_GRAPH_DATA.CLEAR,
  });
  store.dispatch({
    type: ANALYTICS_CARD_DATA.RESET,
  });
  store.dispatch({
    type: ANALYTICS_INTENT_DATA.RESET,
  });
  if (isFilterClicked) {
    store.dispatch({
      type: ANALYTICS_FILTERS.APPLY,
    });
    saveFiltersOnClick(history);
  }

  store.dispatch({
    type: ANALYTICS_DASHBOARD_SET_APPLIED_CAMPAIGNS_ASSETS.SET,
  });
  store.dispatch({
    type: ANALYTICS_DASHBOARD.SET_CAMPAIGN_FILTERS,
  });
  store.dispatch({
    type: ANALYTICS_INTENT_DATA.EXPORT_LOAD,
    payload: true,
  });
  store.dispatch({
    type: ANALYTICS_EMAIL_TRENDS.RESET,
  });
  store.dispatch({
    type: ANALYTICS_CLICK_TRENDS.RESET,
  });
  removeQueryParams();
  // updateTestEmailFilter();
};

export const moveSelectedFiltersToApplied = () => {
  store.dispatch({
    type: ANALYTICS_DASHBOARD_SET_APPLIED_CAMPAIGNS_ASSETS.SET,
  });
};
export const moveAppliedFiltersToSelected = () => {
  store.dispatch({
    type: ANALYTICS_DASHBOARD_SET_APPLIED_CAMPAIGNS_ASSETS.UNSET,
  });
};

export const setQueryParamsRemoved = () => {
  store.dispatch({
    type: ANALYTICS_DASHBOARD_SET_APPLIED_CAMPAIGNS_ASSETS.REMOVE_QUERY_PARAMS_SET,
  });
};

export const unsetEmailDropdownCall = () => {
  store.dispatch({
    type: ANALYTICS_DASHBOARD_SET_APPLIED_CAMPAIGNS_ASSETS.UNSET_RESTRICT_EMAIL_DROPDOWN_PARAM,
  });
};

export const filterButtonPressReset = () => {
  store.dispatch({
    type: ANALYTICS_FILTERS.RESET,
  });
};

export const resetRedirectUrls = () => {
  store.dispatch({
    type: ANALYTICS_ACCOUNTS_DATA.RESET_REDIRECT_URL,
  });
  store.dispatch({
    type: CONTACT_ANALYTICS.RESET_REDIRECT_URL,
  });
};

export const updateCampaignLimit = (value: boolean) => {
  store.dispatch({
    type: ANALYTICS_DASHBOARD.SET_CAMPAIGN_LIMIT,
    payload: value,
  });
};

const saveFiltersOnClick = (history: NavigateFunction) => {
  const storeState = store.getState();
  const selectedCampaignIds = storeState.analyticsDashboard.selectedCampaignsIds;
  const excludeCampaignIds = storeState.analyticsDashboard.excludeCampaignsIds;
  const selectedEmailsIds = storeState.analyticsDashboard.selectedAssetsIds;
  const excludeEmailsIds = storeState.analyticsDashboard.excludeAssetsIds;
  const selectedWorkflowsIds = storeState.analyticsDashboard.selectedWorkflowsIds;
  // const isAllCampaigns = storeState.analyticsDashboard.campaignsFilters.isAllCampaigns;
  const isWorkflow = storeState.analyticsDashboard.isWorkflow;
  const isShareProfile = storeState.analyticsDashboard.isShareProfile;
  const isDailyIQ = storeState.analyticsDashboard.isDailyIQ;
  const isWeeklyAccountInsights = storeState.analyticsDashboard.isWeeklyAccountInsights;
  const isTestEmailFilter = storeState.analyticsDashboard.isTestEmailFilter;
  const startDate = storeState.analyticsGraph.startDate;
  const endDate = storeState.analyticsGraph.endDate;
  const appliedDateObject = storeState.analyticsGraph.selectedDatesObject;
  const selectAllDropdownEmails = storeState.analyticsDashboard.selectAllDropdownEmails;
  const unselectAllDropdownEmails = storeState.analyticsDashboard.unselectAllDropdownEmails;
  const searchedEmailList = storeState.analyticsDashboard.searchedEmailList;
  const campaigns = storeState.analyticsDashboard.campaigns;
  let campaign_ids = [];
  let email_ids = [];
  if (isShareProfile) {
    campaign_ids = ['1'];
    email_ids = selectedEmailsIds;
    // email_ids = ['1'];
  } else if (isDailyIQ) {
    campaign_ids = ['2'];
    // email_ids = ['2'];
  } else if (isWeeklyAccountInsights) {
    campaign_ids = ['3'];
    // email_ids = ['3'];
  } else {
    campaign_ids = selectedCampaignIds;
    email_ids = selectedEmailsIds;
  }
  let list = Array<any>();
  if (searchedEmailList.length) {
    list = searchedEmailList.map((item: ISearchedEmailDropdownList) => {
      return {
        term: item.term,
        select_all: item.selectAll,
        email_ids: item.emailIds.length ? item.emailIds.join().split(',') : [],
      };
    });
  }
  const params: any = {
    start_date: startDate,
    end_date: endDate,
    is_workflow: isWorkflow,
    all_campaigns: campaigns.length === selectedCampaignIds.length && selectAllDropdownEmails && !isWorkflow,
    daily_IQ: isDailyIQ,
    share_profile: isShareProfile,
    weekly_account_insights: isWeeklyAccountInsights,
    campaign_ids:
      isWorkflow || (campaigns.length === selectedCampaignIds.length && selectAllDropdownEmails)
        ? []
        : campaign_ids.join().split(','),
    include_emails:
      email_ids.length && (unselectAllDropdownEmails || isDailyIQ || isWeeklyAccountInsights)
        ? email_ids.join().split(',')
        : [],
    workflow_ids: isWorkflow ? selectedWorkflowsIds.join().split(',') : [],
    exclude_campaign_ids: [],
    exclude_emails: selectAllDropdownEmails && excludeEmailsIds.length ? excludeEmailsIds.join().split(',') : [],
    applied_date_object: appliedDateObject,
    is_test_email: isTestEmailFilter,
    select_all: selectAllDropdownEmails,
    unselect_all: unselectAllDropdownEmails,
    search_list: list,
  };
  saveAnalyticsFilterService(JSON.stringify(params)).then((response) => {
    const newParam = response.data.id;
    const urlSearchParams = new URLSearchParams(window.location.search);
    urlSearchParams.set('fs_id', newParam);
    const newUrl = `${window.location.pathname}?${urlSearchParams.toString()}`;
    let filterData = {};
    if (localStorage.getItem('analyticsFiltersWithId')) {
      filterData = JSON.parse(localStorage.getItem('analyticsFiltersWithId') || '');
      if (filterData) {
        filterData.saved_data = params;
        localStorage.removeItem('analyticsFiltersWithId');
        localStorage.setItem('analyticsFiltersWithId', JSON.stringify(filterData));
      }
    }
    history(newUrl, { replace: true });
  });
};

export const applyFilterUsingFilterId = () => {
  const fsId = getAnalyticsFilterId();
  getAnalyticsFilterService(fsId).then((response) => {
    // saving the response in local storage to use once campaigns, emails and workflows are loaded
    localStorage.removeItem('analyticsFiltersWithId');
    localStorage.setItem('analyticsFiltersWithId', JSON.stringify(response.data));
    // getAnalyticsCampaignsAssetsList(false, true);
    // applyFiltersFromLocalStorage(response.data);
  });
};

export const applyFiltersFromLocalStorage = (data: any) => {
  const analyticsDashboard = store.getState().analyticsDashboard;
  const campaigns = analyticsDashboard.campaigns;
  const assets = analyticsDashboard.assets;
  const filters = data?.saved_data;
  const isTestEmailFilter = filters.is_test_email;
  const allCampaigns = filters.all_campaigns;
  if (filters.share_profile) {
    setShareProfileFilter(true);
    store.dispatch({
      type: ANALYTICS_DASHBOARD.SET_CAMPAIGN_FILTERS,
    });
  }
  if (filters.daily_IQ) {
    setDailyIqFilter(true);
    store.dispatch({
      type: ANALYTICS_DASHBOARD.SET_CAMPAIGN_FILTERS,
    });
  }
  if (filters.weekly_account_insights) {
    setWeeklyAccountInsightsFilter(true);
    store.dispatch({
      type: ANALYTICS_DASHBOARD.SET_CAMPAIGN_FILTERS,
    });
  }
  if (filters.all_campaigns) {
    resetDashboardCampaignFilters();
    // to avoid the reset calling in the setCampaignsFilter function
    selectAllCampaigns();
  }

  if (filters.campaign_ids.length > 0) {
    // if (filters.campaign_ids.length === 1) {
    //   filters.campaign_ids.forEach((id: string) => {
    //     if (['1', '2', '3'].includes(id.toString())) {
    //       return;
    //     }
    //     selectCampaign(parseInt(id));
    //   });
    // } else {
    //   filters.campaign_ids.forEach((id: string) => selectCampaign(parseInt(id)));
    // }
    filters.campaign_ids.forEach((id: string) => selectCampaign(parseInt(id)));
  }
  if (filters.is_workflow) {
    toggleWorkflowFilter(true);
    if (filters.workflow_ids) {
      setWorkflowAssetsFilter({ isAllType: true });
      setDefaultWorkflow(parseInt(filters.workflow_ids[0]));
      reorderWorkflows();
    }
    // if (filters.email_ids) {
    //   unselectAllWorkflowEmails();
    //   filters.email_ids.forEach((emailId: any) => {
    //     selectWorkflowAsset(emailId, filters.workflow_ids[0]);
    //   });
    // }
  }

  setEmailDropdownFields(
    filters.select_all,
    filters.unselect_all,
    filters.search_list.map((item: any) => {
      return {
        term: item.term,
        selectAll: item.select_all,
        emailIds: item.email_ids.map((id: string) => parseInt(id)),
      };
    }),
    filters.include_emails.map((id: string) => parseInt(id)),
    filters.exclude_emails.map((id: string) => parseInt(id)),
  );

  if (!filters.is_workflow) moveSelectedFiltersToApplied();
  store.dispatch({ type: ANALYTICS_DASHBOARD_GRAPH_DATA.RESET_DATES });
  store.dispatch({
    type: ANALYTICS_DASHBOARD_GRAPH_DATA.SET_DATES_OBJECT,
    payload: filters.applied_date_object,
  });
  store.dispatch({
    type: ANALYTICS_DASHBOARD_GRAPH_DATA.SET_APPLIED_DATES_OBJECT,
    payload: filters.applied_date_object,
  });
  if (filters.applied_date_object.value === 'custom') {
    const start_date = filters.start_date;
    const end_date = filters.end_date;
    store.dispatch({
      type: ANALYTICS_DASHBOARD_GRAPH_DATA.SET_DATES,
      ...{ start_date, end_date },
    });
    store.dispatch({
      type: ANALYTICS_DASHBOARD_GRAPH_DATA.SET_APPLIED_DATES,
      ...{ start_date, end_date },
    });
  } else {
    analyticsDatesFilterChange(filters.applied_date_object);
  }
  reorderCampaignsAndEmails();
  if (filters.workflow_ids.length === 0) {
    // add this check because filterAssets becomes empty if we go to set or reset test email filter also we are hiding test email if workflow is selected
    if (isTestEmailFilter) {
      setTestEmailAssetsFilter();
    } else {
      resetTestEmailAssetsFilter();
    }
  }
};
